<template>
  <main>
    <UiQuickSettings />
    <MainSection />
    <WorldMetrics />
    <HowItWorksSection />
    <WhyUs />
    <BennefitsSection />
    <FAQSection />
  </main>
</template>

<script setup lang="ts">
import UiQuickSettings from '@/components/ui/UiQuickSettings.vue';
import MainSection from '@/components/pages/home/MainSection.vue';
import HowItWorksSection from '@/components/pages/home/HowItWorksSection.vue';
import WhyUs from '@/components/pages/home/WhyUs.vue';
import BennefitsSection from '@/components/pages/home/BennefitsSection.vue';
import WorldMetrics from '@/components/pages/home/WorldMetrics.vue';
import FAQSection from '@/components/pages/home/FAQSection.vue';
</script>
